import moment from 'moment';
function _moment(value) {
  if (value == null || value == undefined || value == '') {
    return '';
  } else {
    return moment(value).format('YYYY-MM-DD');
  }
}
export default _moment;
